module.exports = __webpack_public_path__ + "img/1.6d350c8.png";